<div class="app-full-height px-4 pt-4">
  <div class="flex flex-row justify-end items-center py-4">
    <button mat-flat-button color="primary" (click)="addTemplate()">
      Add Template
    </button>
  </div>
  <app-template-table></app-template-table>
</div>
